import React, { Component } from 'react'
import { Row, Col, Card, CardBody, Container, Table, Button } from "reactstrap";

import Breadcrumbs from "../../components/Common/Breadcrumb"

import MapsPoint from "./MapsPoint";
import { crowdLocationUrl } from '../../helpers/url';

export default class Back extends Component {
    constructor(props) {
        super(props);
        this.state={
            breadcrumbItems : [
                { title : "UTJD", link : "/dashboard" },
                { title : "Location Point", link : "#" },
            ],
            data: [],
            iconsrc: ["ri-book-2-fill", "ri-women-fill", "ri-men-fill", "ri-building-fill", "ri-home-gear-fill", "ri-lock-fill", "ri-map-pin-3-fill"]
        }
        this.submitLocationData = this.submitLocationData.bind(this);
    }

    componentDidMount() {
        this.getAllData();
    }

    getAllData() {
        const session = JSON.parse(sessionStorage.getItem('authUser'));
        const userId = session.payload.sub;
        const accessToken = session.jwtToken;
        const path = crowdLocationUrl+userId;
        fetch(path, {
            method: "GET",
            headers: {"Content-Type": "application/json", "Authorization": accessToken}
        })
        .then(res=>res.json())
        .then((data) => {
            this.setState({
                data: data
            })
        })
    }

    submitLocationData (e,dataInfo) {
        const session = JSON.parse(sessionStorage.getItem('authUser'));
		const userId = session.payload.sub;
        const accessToken = session.jwtToken;
        fetch(crowdLocationUrl, {
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify({
                locationId: 0, 
                latitude: dataInfo.latitude, 
                longitude: dataInfo.longitude, 
                observation: dataInfo.observation, 
                userId: userId
            })
        }).then(res=>res)
        .then(message => {
            console.log(message);
            this.getAllData();
        })
    };


    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                        <Breadcrumbs title="Location Point" breadcrumbItems={this.state.breadcrumbItems} />

                        <MapsPoint submitData = {this.submitLocationData} />
                        <Row>
                            <Col xs={12}>
                                <Card>
                                    <CardBody>
                                    <h4 className="card-title">Your registered Locations</h4>
                                        <p className="card-title-desc">Point the location of interest</p>

                                        <div className="table-rep-plugin">
                                            <div className="table-responsive mb-0" data-pattern="priority-columns">
                                                <Table id="tech-companies-1" striped bordered responsive>
                                                    <thead>
                                                        <tr>
                                                            <th>ID</th>
                                                            <th data-priority="1">Observations</th>
                                                            <th data-priority="3">Lat</th>
                                                            <th data-priority="1">Lng</th>
                                                            <th data-priority="3">Registered</th>
                                                            <th data-priority="4">Upload</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state?.data.map((content, i) => 
                                                            content.disable ? "" :
                                                            <tr>
                                                                <td>{content.locationId}</td>
                                                                <td>{content.observation}</td>
                                                                <td>{content.latitude}</td>
                                                                <td>{content.longitude}</td>
                                                                <td>{new Date(content.registeredDate).toLocaleString('no-EU')}</td>
                                                                <td>
                                                                    <Button color="light" block type="button" className="btn-block waves-effect  mt-2 waves-light">
                                                                        <i className="mdi mdi-book-plus-multiple-outline"></i> Upload
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        
                    </Container>
                </div>
            </React.Fragment>
            
        )
    }
}
